<template>
  <div class="mb-4" style="min-height: 300px">
    <ViewLoader v-if="loading"/>
    <div v-else>
      <ToastVoucherFreePhotos :free-photos-count="freePhotosCount" :photos-in-cart-count="photosInCartCount"/>
      <b-toast id="toast-add-cart-action-feedback" variant="light"
               :auto-hide-delay="photosInCartCount >= qtyForPhotoPackage ? 6000 : 6000" v-if="qtyForPhotoPackage">
        <div class="d-flex align-items-center py-2">
          <div class="text-center">
            <div :class="{'px-4': photosInCartCount < qtyForPhotoPackage}">
              <span v-if="photosInCartCount >= qtyForPhotoPackage">
                {{ $t('toast_cart_photo_package_feedback.text2', {price: priceForAllPhotos}) }}
              </span>
              <span v-else>
                {{ $t('toast_cart_photo_package_feedback.text1') }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mt-2 justify-content-center" v-if="photosInCartCount >= qtyForPhotoPackage">
          <div class="col-6">
            <b-button variant="light" size="sm" block @click="$bvToast.hide('toast-add-cart-action-feedback')">
              {{ $t('toast_cart_photo_package_feedback.btn_cancel') }}
            </b-button>
          </div>
          <div class="col-6">
            <b-button variant="primary" block size="sm" @click="$emit('photo-package-activated')">
              {{ $t('toast_cart_photo_package_feedback.btn_ok') }}
            </b-button>
          </div>
        </div>
      </b-toast>

      <ModalAlert modalId="modal-currency-mismatch"
                  :title="$t('modal_currency_mismatch.title')"
                  :bodyText="$t('modal_currency_mismatch.text')"
                  :okBtnLabel="$t('modal_currency_mismatch.btn_ok')"/>
      <template v-if="hasBuyablePhotos">
        <div class="collage-photo__group-title">
          <h6 class="font-weight-medium">{{ $t('pages.checkins_detail.my_photos') }}</h6>
        </div>
        <div class="row collage-photo">
          <CollagePhotoItemBuyable v-for="(photo, index) in photos" :key="index"
                                   ref="collagePhotoItemBuyable"
                                   :index="index"
                                   :photo="photo"
                                   :digital-item-id="digitalItemId"
                                   :picacode="checkin.picacode"
                                   :has-photo-original="checkin.pica_service.has_media_original"
                                   :enable-zoom="false" :use-select-label="freePhotosCount - photosInCartCount > 0"
                                   :arrange-two-cols-for-mobile="false"
                                   @digital-item-updated="updateDigitalItemId"
                                   @photo-cart-added="checkCartAndShowToast"
                                   @zoom-clicked="showGallery(index)"/>
        </div>
      </template>

      <ModalPhotoGallery ref="modalPhotoGallery"
                         :photos="photos"
                         :digital-item-id="digitalItemId"
                         :use-select-label="freePhotosCount - photosInCartCount > 0"
                         :event-name="checkin.pica_service.event_name"
                         :event-date="checkin.pica_service.event_start_at"
                         :picacode="checkin.picacode"
                         @digital-item-updated="updateDigitalItemId"
                         @photo-cart-added="checkCartAndShowToast"/>


    </div>
  </div>
</template>


<script>
import CollagePhotoItemBuyable from '@/components/CollagePhotoItemBuyable'
import ModalPhotoGallery from '@/components/ModalPhotoGallery'
import ModalAlert from '@/components/ModalAlert'
import ToastVoucherFreePhotos from '@/components/ToastVoucherFreePhotos'
import ViewLoader from "@/components/ViewLoader.vue";

export default {
  components: {
    ViewLoader,
    ModalAlert,
    ToastVoucherFreePhotos,
    CollagePhotoItemBuyable,
    ModalPhotoGallery,
  },

  props: [
    'checkin',
    'priceForAllPhotos',
    'photos',
    'loading'
  ],

  data() {
    return {
      // Se è settato digitalItemId, vuol dire che nel carrello c'è un item corrispondente al picacode corrente
      digitalItemId: null,
      isPhotoPackagePriceReached: false,
      qtyForPhotoPackage: null,
    }
  },

  created() {
    this.updateDigitalItemId()
    if (this.checkin.price_list && this.checkin.price_list.items) {
      const priceForAllPhotos = this.getPriceByQty(-1)
      const limitIndex = this.checkin.price_list.items.findIndex(i => this.getPriceByQty(i.quantity) === priceForAllPhotos)
      if (limitIndex > 0) {
        this.qtyForPhotoPackage = this.checkin.price_list.items[limitIndex - 1].quantity + 1
      }
    }
  },

  computed: {
    eventClosed() {
      return this.checkin.pica_service.is_tagging_completed
    },

    picacode() {
      return this.checkin.picacode
    },

    hasBuyablePhotos() {
      return this.checkin.has_buyable_photos
    },

    showPackageBanners() {
      return (this.eventClosed && this.hasBuyablePhotos) || !this.eventClosed
    },

    showPackageBannersBottom() {
      return this.showPackageBanners && this.photos.length > 6
    },

    photosInCartCount() {
      const digitalItem = this.$store.getters['cart/getDigitalItemByPicacode'](this.checkin.picacode)
      return digitalItem && digitalItem.photos ? digitalItem.photos.length : 0
    },

    freePhotosCount() {
      return this.checkin.price_list && this.checkin.price_list.free_photos_count ? this.checkin.price_list.free_photos_count : 0
    }
  },

  methods: {
    updateDigitalItemId() {
      const digitalItem = this.$store.getters['cart/getDigitalItemByPicacode'](this.picacode)
      this.digitalItemId = digitalItem ? digitalItem.id : null
      this.checkCartAndShowToast()
    },

    checkCartAndShowToast() {
      if (this.qtyForPhotoPackage === null) return
      if (this.photosInCartCount === 0) {
        this.$bvToast.hide('toast-add-cart-action-feedback')
        return
      }
      const allPhotosPkgIndex = this.checkin.price_list.items.findIndex(item => item.quantity === -1)
      if (allPhotosPkgIndex <= 0) return
      if (this.photosInCartCount === this.qtyForPhotoPackage || this.photosInCartCount === this.qtyForPhotoPackage - 1) {
        this.$bvToast.show('toast-add-cart-action-feedback')
      } else {
        this.$bvToast.hide('toast-add-cart-action-feedback')
      }
    },

    getPriceByQty(qty, originalPrice = false, formatted = true) {
      if (this.isPromo) {
        return (0).toLocaleString(this.locale, {
          style: 'currency',
          currency: this.checkin.pica_service.currency,
          currencyDisplay: 'symbol',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })
      }
      // this.checkin.price_list will be null when the event is promo
      const item = this.checkin.price_list.items.find(item => item.quantity === qty)
      if (formatted) {
        return item ? (originalPrice ? item.price_original_formatted : item.price_formatted) : null
      } else {
        return item ? (originalPrice ? item.price_original : item.price) : null
      }

    },

    showGallery(index) {
      this.$refs.modalPhotoGallery.show(index)
    }
  }
}
</script>
